import salesStaticService from './sales-static/salesStaticService'
import reservationService from './reservation/reservationService'
export { salesStaticService, reservationService }
export { signIn, signInByEmailOrPhone, signUpWithEmail, activateEmail } from './auth/authService'
